import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  return (
    <Layout>
      <div className="pt-24 pb-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'AboutPage',
                name: '关于小樱动漫',
                description: '小樱动漫品牌介绍、用户口碑与联系方式',
                url: 'https://www.xiaoyinganime.com/about',
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: '小樱动漫上的资源是正版的吗？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '是的！小樱动漫与国内外多家版权方建立了深度合作关系，所有上架内容均获得正版授权。我们坚决支持正版，为创作者提供应有的回报。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '小樱动漫支持哪些设备观看？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '小樱动漫支持全平台观看，包括PC网页端、手机移动端、平板设备。追番进度和收藏列表自动云端同步，随时随地无缝切换。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '新番什么时候更新？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '我们力争在日本播出后24小时内上线中文字幕版本。热门新番通常会在当晚或次日更新，具体更新时间请关注各作品的详情页公告。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '小樱动漫是免费的吗？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '小樱动漫大部分内容免费观看。部分最新番剧和剧场版可能需要会员权限。我们提供多种会员方案，满足不同用户的观看需求。',
                    },
                  },
                ],
              }),
            }}
          />

          <Breadcrumb items={[{ label: '关于我们' }]} />

          {/* 品牌介绍 */}
          <section className="mb-14">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">关于小樱动漫</h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-lg font-heading text-foreground-900 mb-3">品牌故事</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  小樱动漫诞生于2020年，由一群热爱动漫文化的年轻人创立。我们深知每一位动漫爱好者对于正版高清内容的渴望，也深知当前动漫观看体验中的种种痛点——画质模糊、弹窗广告、翻译质量参差不齐、更新不及时……
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  因此，小樱动漫从创立之初就确立了三大核心原则：<strong>正版授权、高清画质、极速更新</strong>。我们与国内外数十家版权方建立了深度合作关系，确保平台上的每一部作品都拥有合法授权，每一位创作者都能获得应有的回报。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  如今，小樱动漫已发展成为涵盖日漫、国漫、剧场版、经典动画等全品类内容的综合性动漫平台。我们拥有超过<strong>5000部</strong>正版授权作品，累计服务超过<strong>1000万</strong>动漫爱好者。
                </p>
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20interior%20with%20anime%20posters%20on%20wall%2C%20warm%20ambient%20lighting%2C%20minimalist%20Japanese%20design%2C%20creative%20workspace%20atmosphere%2C%20sakura%20decorative%20elements%2C%20professional%20photography&width=800&height=500&seq=about-brand&orientation=landscape"
                  alt="小樱动漫办公室"
                  className="w-full rounded-lg object-cover"
                />
              </div>
            </div>
          </section>

          {/* 品牌亮点 */}
          <section className="mb-14 py-10 bg-background-100 rounded-2xl px-4 md:px-10">
            <h2 className="text-xl font-heading text-foreground-950 text-center mb-8">为什么选择小樱动漫</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-shield-check-line', title: '正版授权', desc: '全部内容合法授权，支持正版为创作者助力' },
                { icon: 'ri-4k-line', title: '高清画质', desc: '1080P/4K超清画质，沉浸式观看体验' },
                { icon: 'ri-flashlight-line', title: '极速更新', desc: '日本播出后24小时内上线中文字幕' },
                { icon: 'ri-device-line', title: '多端同步', desc: 'PC/手机/平板全支持，数据云端同步' },
              ].map((item, i) => (
                <div key={i} className="text-center p-4">
                  <div className="w-14 h-14 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                    <i className={`${item.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h4>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 用户口碑 */}
          <section className="mb-14">
            <h2 className="text-xl font-heading text-foreground-950 mb-6">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: '二次元老司机',
                  avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20young%20person%2C%20minimalist%20design%2C%20clean%20background%2C%2C%20warm%20tones&width=100&height=100&seq=avatar-01&orientation=squarish',
                  rating: 5,
                  text: '用了两年小樱动漫了，资源真的很全！画质也稳定，最重要的是没有乱七八糟的广告。追番体验拉满，强烈推荐！',
                },
                {
                  name: '追番少女小圆',
                  avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20avatar%20of%20girl%2C%20minimalist%20design%2C%20clean%20pastel%20background%2C%20warm%20tones&width=100&height=100&seq=avatar-02&orientation=squarish',
                  rating: 5,
                  text: '国漫资源比我想象的多好多！《时光代理人》《雾山五行》都能看到，画质还是1080P的，国漫爱好者狂喜！',
                },
                {
                  name: '动画电影迷',
                  avatar: 'https://readdy.ai/api/search-image?query=Modern%20anime%20style%20portrait%20avatar%2C%20minimalist%20design%2C%20clean%20neutral%20background%2C%20warm%20tones&width=100&height=100&seq=avatar-03&orientation=squarish',
                  rating: 5,
                  text: '剧场版的资源太棒了！吉卜力、新海诚的全集都有，周末在家投影看简直太享受了。小樱动漫永远滴神！',
                },
              ].map((review, i) => (
                <div key={i} className="p-5 rounded-lg bg-background-100">
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: review.rating }).map((_, j) => (
                          <i key={j} className="ri-star-fill text-accent-500 text-xs"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 数据展示 */}
          <section className="mb-14">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {[
                { value: '5000+', label: '正版内容' },
                { value: '1000万+', label: '累计用户' },
                { value: '99.9%', label: '可用性' },
                { value: '24h', label: '更新速度' },
              ].map((stat, i) => (
                <div key={i} className="text-center p-5 rounded-lg bg-accent-50">
                  <p className="text-2xl md:text-3xl font-heading text-accent-600">{stat.value}</p>
                  <p className="text-xs text-accent-700 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </section>

          {/* 联系我们 */}
          <section className="mb-14">
            <h2 className="text-xl font-heading text-foreground-950 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-5 rounded-lg bg-background-100 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-primary-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h4>
                  <p className="text-xs text-foreground-500">bd@xiaoyinganime.com</p>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-100 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                  <i className="ri-question-answer-line text-accent-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">客服支持</h4>
                  <p className="text-xs text-foreground-500">support@xiaoyinganime.com</p>
                </div>
              </div>
              <div className="p-5 rounded-lg bg-background-100 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-secondary-300 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-secondary-700"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                  <p className="text-xs text-foreground-500">上海市浦东新区张江高科技园区动漫大厦</p>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-14">
            <h2 className="text-xl font-heading text-foreground-950 mb-6">常见问题</h2>
            <div className="space-y-3">
              {[
                { q: '小樱动漫上的资源是正版的吗？', a: '是的！小樱动漫与国内外多家版权方建立了深度合作关系，所有上架内容均获得正版授权。我们坚决支持正版，为创作者提供应有的回报。' },
                { q: '小樱动漫支持哪些设备观看？', a: '小樱动漫支持全平台观看，包括PC网页端、手机移动端、平板设备。追番进度和收藏列表自动云端同步，随时随地无缝切换。' },
                { q: '新番什么时候更新？', a: '我们力争在日本播出后24小时内上线中文字幕版本。热门新番通常会在当晚或次日更新，具体更新时间请关注各作品的详情页公告。' },
                { q: '小樱动漫是免费的吗？', a: '小樱动漫大部分内容免费观看。部分最新番剧和剧场版可能需要会员权限。我们提供多种会员方案，满足不同用户的观看需求。' },
                { q: '如何投稿或申请成为创作者？', a: '欢迎原创动画创作者加入小樱动漫！请将作品信息和联系方式发送至 bd@xiaoyinganime.com，我们的内容团队会在7个工作日内回复。' },
              ].map((faq, i) => (
                <details key={i} className="group p-5 rounded-lg bg-background-100 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-900 list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 transition-transform group-open:rotate-180"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </details>
              ))}
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}